import React from "react";
import ReactDOM from "react-dom/client";
import { createStore } from "redux";
import { Provider } from "react-redux";
import { PersistGate } from "redux-persist/integration/react";
import "./index.css";
import App from "./App";
import AppS from "./AppS";
import AppLogin from "./AppLogin";
import AppGroup from "./AppGroup";
import AppMobile from "./AppMobile";

import reducer from "./reducer";
import { persistor } from "./store/store";
// import { AuthProvider } from './context/AuthContext ';

const root = ReactDOM.createRoot(document.getElementById("root"));
const store = createStore(reducer);

// root.render(

//   <React.StrictMode>
//     <Provider store={store}>
//       <AuthProvider>
//         <App />
//       </AuthProvider>
//     </Provider>
//   </React.StrictMode>

// );

// // If you want to start measuring performance in your app, pass a function
// // to log results (for example: reportWebVitals(console.log))
// // or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();

import { RouterProvider, createBrowserRouter } from "react-router-dom";

// App
import Main from "./components/main/mainPage";
import Error from "./common/error";
import Login from "./components/login/loginPage";
import UserJoinForm from "./components/login/component/userJoinForm";
import BusinessJoinForm from "./components/login/component/businessJoinForm";
import TypeJoin from "./components/login/component/typeJoin";
import MemberSearch from "./components/login/component/memberSearch";
import Policy from "./components/policy/policyPage";
import SelfService from "./components/selfService/selfService";
import Storage from "./components/selfService/storage";
import Retrieve from "./components/selfService/retrieve";
import InfoGroup from "./components/info/infoGroup";
import InfoProject from "./components/info/infoProject";
import InfoShop from "./components/info/infoShop";
import InfoScheduler from "./components/info/infoScheduler";
import InfoSubscribe from "./components/info/infoSubscribe";
import FaqPage from "./components/notice/faqPage";
import Notice from "./components/notice/noticePage";
import ReleaseNotesPage from "./components/notice/releaseNotesPage";
import HelpPage from "./components/notice/helpPage";
import HelpWritePage from "./components/notice/helpWritePage";
import Stamp from "./components/landing/stamp";
import AppInstall from "./components/landing/appInstall";
import Coupon from "./components/landing/coupon";
import ShareReport from "./components/landing/shareReport";
import MenuBoard from "./components/menu/menuBoard";
import MenuBoardCart from "./components/menu/menuBoardCart";
import MenuBoardOrder from "./components/menu/menuBoardOrder";
import MenuBoardSuccess from "./components/menu/menuBoardSuccess";
import MenuBoardFail from "./components/menu/menuBoardFail";
import MenuBoardHome from "./components/menu/menuBoardHome";

// AppS
import Shop from "./components/shopping/shop/shopPage";
import ThemeSelector from "./components/shopping/shopping/ThemeSelector";
import Company from "./components/shopping/company/companyPage";
import ProductsList from "./components/shopping/productList/productsListPage";
import ShoppingNotice from "./components/shopping/notice/noticePage";
import Portfolio from "./components/shopping/portfolio/portfolioPage";
import Search from "./components/shopping/search/searchPage";
import ProductsView from "./components/shopping/productsView/productViewPage";
import ShoppingLogin from "./components/shopping/login/shoppingLogin";
import ShoppingNoticeView from "./components/shopping/notice/noticeViewPage";
import PortfolioViewPage from "./components/shopping/portfolio/portfolioViewPage";
import ShoppingType from "./components/shopping/join/shoppingType";
import ShoppingBusiness from "./components/shopping/join/shoppingBusiness";
import ShoppingJoin from "./components/shopping/join/shoppingJoin";
import HelpViewPage from "./components/shopping/notice/helpViewPage";
import ShoppingMyPage from "./components/shopping/mypage/shoppingMyPage";
import OrderHistory from "./components/shopping/mypage/component/orderHistory";
import EditProfile from "./components/shopping/mypage/component/editProfile";
import Addresses from "./components/shopping/mypage/component/addresses";
import Cart from "./components/shopping/mypage/component/cart";
import ShopDashboard from "./components/shopping/mypage/component/mypage";
import OrderDetail from "./components/shopping/mypage/component/orderDetail";
import Order from "./components/shopping/mypage/component/order";
import Fail from "./components/shopping/mypage/component/fail";
import Success from "./components/shopping/mypage/component/success";
import OrderDelivery from "./components/shopping/mypage/component/orderDelivery";

// AppLogin
import Mypage from "./components/mypage/dashboard/dashboardPage";
import Hompage from "./components/mypage/homepage/hompage";
import RegisterNoticeView from "./components/mypage/homepageSetting/registerNoticeViewPage";
import RegisterNoticeWrite from "./components/mypage/homepageSetting/registerNoticeWritePage";
import RegisterPortView from "./components/mypage/homepageSetting/registerPortViewPage";
import RegisterPhotoUpload from "./components/mypage/homepageSetting/registerPhotoUploadPage";
import ProjectList from "./components/mypage/project/projectListPage";
import ProjectCreate from "./components/mypage/project/projectCreatePage";
import ProjectCreateSec from "./components/mypage/project/projectCreateSecPage";
import ProjectDetailPage from "./components/mypage/project/projectDetailPage";
import ProjectFileBoxPage from "./components/mypage/project/projectFileBoxPage";
import Scheduler from "./components/mypage/scheduler/scheduler";
import CalendarEntry from "./components/mypage/scheduler/calendarEntry";
import DetailEvent from "./components/mypage/scheduler/detailEvent";
import DdayEntry from "./components/mypage/scheduler/ddayEntry";
import MakeDomainPage from "./components/mypage/homepage/makeDomainPage";
import CreateReleaseNotes from "./components/mypage/dashboard/createReleaseNotesPage";
import NotifyPage from "./components/mypage/dashboard/notifyPage";
import ModifyProfilePage from "./components/mypage/dashboard/modifyProfilePage";
import IntegratedSearchPage from "./components/mypage/integratedSearch/integratedSearchPage";
import KioskPage from "./components/mypage/kiosk/kioskPage";
import KioskSalesCheckPage from "./components/mypage/kiosk/kioskSalesCheckPage";
import KioskRreservationStatusPage from "./components/mypage/kiosk/kioskRreservationStatusPage";
import KioskPickUpPage from "./components/mypage/kiosk/kioskPickUpPage";
import KioskStoragePage from "./components/mypage/kiosk/kioskStoragePage";
import Bbdabang from "./components/mypage/bbdabang/bbdabang";
import BbdabangSalesCheck from "./components/mypage/bbdabang/bbdabangSalesCheck";
import BbdabangRreservationStatus from "./components/mypage/bbdabang/bbdabangRreservationStatus";
import BbdabangPickUp from "./components/mypage/bbdabang/bbdabangPickUp";
import BbdabangStorage from "./components/mypage/bbdabang/bbdabangStorage";
import Store from "./components/mypage/store/store";

// AppGroup
import Group from "./components/group/group";
import MyGroup from "./components/group/myGroup";
import CreateGroup from "./components/group/create";
import GroupLogin from "./components/group/groupLogin";
import Feeds from "./components/group/feeds";
import GroupDetails from "./components/group/groupDetails";
import GroupAll from "./components/group/groupAll";
import FeedWrite from "./components/group/feedWrite";
import GroupHome from "./components/group/component/groupDetails/home";
import GroupSearch from "./components/group/component/groupDetails/search";
import GroupMembers from "./components/group/component/groupDetails/members";
import GroupSetting from "./components/group/component/groupDetails/setting";
import GroupCommunity from "./components/group/component/groupDetails/community";

import Mobile from "./components/mobile/mobile";

const router = createBrowserRouter([
  {
    path: "/",
    element: <App />,
    errorElement: <Error />,
    children: [
      { index: true, element: <Main /> },
      { path: "/policy", element: <Policy /> },
      { path: "/help", element: <HelpPage /> },
      { path: "/help/write", element: <HelpWritePage /> },
      { path: "/notice", element: <Notice /> },
      { path: "/releaseNotes", element: <ReleaseNotesPage /> },
      { path: "/faq", element: <FaqPage /> },
      { path: "/login", element: <Login /> },
      { path: "/type", element: <TypeJoin /> },
      { path: "/join", element: <UserJoinForm /> },
      { path: "/businessJoin", element: <BusinessJoinForm /> },
      { path: "/memberSearch", element: <MemberSearch /> },
      { path: "/app-install", element: <AppInstall /> },
      { path: "/self-service", element: <SelfService /> },
      { path: "/self-service/keep", element: <Storage /> },
      { path: "/self-service/find", element: <Retrieve /> },
      { path: "/info/scheduler", element: <InfoScheduler /> },
      { path: "/info/subscribe", element: <InfoSubscribe /> },
      { path: "/info/group", element: <InfoGroup /> },
      { path: "/info/project", element: <InfoProject /> },
      { path: "/info/shop", element: <InfoShop /> },
      { path: "/stamp", element: <Stamp /> },
      { path: "/coupon", element: <Coupon /> },
      { path: "/share-report", element: <ShareReport /> },
      { path: "menu-board", element: <MenuBoardHome /> },
      { path: "menu-board/:cmpnyNo", element: <MenuBoard /> },
      { path: "menu-board/:cmpnyNo/cart", element: <MenuBoardCart /> },
      { path: "menu-board/:cmpnyNo/order", element: <MenuBoardOrder /> },
      { path: "menu-board/:cmpnyNo/order/success", element: <MenuBoardSuccess /> },
      { path: "menu-board/:cmpnyNo/order/fail", element: <MenuBoardFail /> },
    ],
  },
  {
    path: "/shop",
    element: <AppS />,
    errorElement: <Error />,
    children: [
      { index: true, element: <Shop /> },
      { path: "/shop/login", element: <ShoppingLogin /> },
      // { path: "/shop/search", element: <Search /> },
      {
        path: "/shop/mypage",
        element: <ShoppingMyPage />,
        children: [
          { index: true, element: <ShopDashboard /> },
          { path: "history", element: <OrderHistory /> },
          { path: "history/:orderId", element: <OrderDetail /> },
          { path: "history/:orderId/delivery", element: <OrderDelivery /> },
          { path: "cart", element: <Cart /> },
          { path: "profile", element: <EditProfile /> },
          { path: "address", element: <Addresses /> },
          { path: "order", element: <Order /> },
          { path: "order/success", element: <Success /> },
          { path: "order/fail", element: <Fail /> },
        ],
      },
      { path: "/shop/:url", element: <ThemeSelector /> },
      { path: "/shop/:url/login", element: <ShoppingLogin /> },
      { path: "/shop/:url/type", element: <ShoppingType /> },
      { path: "/shop/:url/join", element: <ShoppingJoin /> },
      { path: "/shop/:url/businessJoin", element: <ShoppingBusiness /> },
      { path: "/shop/:url/company", element: <Company /> },
      { path: "/shop/:url/productsList", element: <ProductsList /> },
      { path: "/shop/:url/productsView/:prdNo", element: <ProductsView /> },
      { path: "/shop/:url/shoppingNotice", element: <ShoppingNotice /> },
      { path: "/shop/:url/shoppingNoticeView/:noticeNo", element: <ShoppingNoticeView /> },
      { path: "/shop/:url/helpView/:helpNo", element: <HelpViewPage /> },
      { path: "/shop/:url/portfolio", element: <Portfolio /> },
      { path: "/shop/:url/portfolioView/:portNo", element: <PortfolioViewPage /> },
      { path: "/shop/:url/search", element: <Search /> },
    ],
  },
  {
    path: "/mypage",
    element: <AppLogin />,
    errorElement: <Error />,
    children: [
      { index: true, element: <Mypage /> },
      { path: "modifyProfile", element: <ModifyProfilePage /> },
      { path: "homepage", element: <Hompage /> },
      { path: "makeDomain", element: <MakeDomainPage /> },
      { path: "createReleaseNotes", element: <CreateReleaseNotes /> },
      { path: "projectList", element: <ProjectList /> },
      { path: "projectCreate", element: <ProjectCreate /> },
      { path: "projectCreateSec", element: <ProjectCreateSec /> },
      { path: "project/:projectNo", element: <ProjectDetailPage /> },
      { path: "filebox", element: <ProjectFileBoxPage /> },
      { path: "scheduler", element: <Scheduler /> },
      { path: "registerNoticeView/:noticeNo", element: <RegisterNoticeView /> },
      { path: "registerNoticeWrite", element: <RegisterNoticeWrite /> },
      { path: "registerPortView/:portNo", element: <RegisterPortView /> },
      { path: "registerPhotoUpload", element: <RegisterPhotoUpload /> },
      { path: "registerPhotoUpload/:portNo", element: <RegisterPhotoUpload /> },
      { path: "scheduler/form", element: <CalendarEntry /> },
      { path: "scheduler/dday", element: <DdayEntry /> },
      { path: "detailEvent/:id", element: <DetailEvent /> },
      { path: "notify", element: <NotifyPage /> },
      { path: "search", element: <IntegratedSearchPage /> },
      { path: "kiosk", element: <KioskPage /> },
      { path: "kiosk/storage", element: <KioskStoragePage /> },
      { path: "kiosk/pickup", element: <KioskPickUpPage /> },
      { path: "kiosk/salesCheck", element: <KioskSalesCheckPage /> },
      { path: "kiosk/reservationStatus", element: <KioskRreservationStatusPage /> },
      { path: "bbdabang", element: <Bbdabang /> },
      { path: "bbdabang/storage", element: <BbdabangStorage /> },
      { path: "bbdabang/pickup", element: <BbdabangPickUp /> },
      { path: "bbdabang/salesCheck", element: <BbdabangSalesCheck /> },
      { path: "bbdabang/reservationStatus", element: <BbdabangRreservationStatus /> },
      { path: "store", element: <Store /> },
    ],
  },
  {
    path: "/group",
    element: <AppGroup />,
    errorElement: <Error />,
    children: [
      { index: true, element: <Group /> },
      { path: "all", element: <GroupAll /> },
      { path: "create", element: <CreateGroup /> },
      { path: "my", element: <MyGroup /> },
      {
        path: "/group/:id",
        element: <GroupDetails />,
        children: [
          { index: true, element: <GroupHome /> },
          { path: "community", element: <GroupCommunity /> },
          { path: "search", element: <GroupSearch /> },
          { path: "members", element: <GroupMembers /> },
          { path: "settings", element: <GroupSetting /> },
        ],
      },
      { path: "/group/login", element: <GroupLogin /> },
      { path: "/group/feed", element: <Feeds /> },
      { path: "/group/feed/write", element: <FeedWrite /> },
    ],
  },
  {
    path: "/mobile",
    element: <AppMobile />,
    errorElement: <Error />,
    children: [{ index: true, element: <Mobile /> }],
  },
]);

root.render(
  <React.StrictMode>
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <RouterProvider router={router} />
      </PersistGate>
    </Provider>
  </React.StrictMode>,
);
